Pixlee.module('Components.Navbar', function(Navbar, App, Backbone, Marionette, $) {
    var _this = this,
        API;
    Navbar.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            var _this = this;
            // Create navbar model with widgetOptions
            this.widgetOptions = options.widgetOptions;
            this.navbarModel = App.reqres.request('get:new:navbar:model', this.widgetOptions);

            // Set photos collection for widget
            this.photos = options.photosCollection;
            this.photoLocations = this.navbarModel.get('location') ? App.request('get:navbar:photo:locations') : {};
            // Set Views
            this.setViews(this.navbarModel, this.photos, this.photoLocations);
        },
        setLayout: function(navbarModel, photosCollection) {
            var _this = this;
            this.navbarLayout = this.getNavbarLayout(navbarModel, photosCollection);
            this.listenTo(this.navbarLayout, {
                'show': this.showRegions,
                'social:logged:in': this.socialLoggedIn,
                'update:results:bar:counter': this.updateResultsBarCounter,
                'render:map:markers': this.renderMapMarkers,
                'analytics:track': this.analyticsTrack,
                'check:location:filter': this.checkLocationFilter
            }, this);
            photosCollection.on('sync', function(collection, resp) {
                _this.navbarLayout.triggerMethod('sync');
            });
        },
        setResultsBarView: function(navbarModel) {
            this.filterItemsCollection = new Backbone.Collection();
            this.resultsBarView = this.getResultsBarView(navbarModel, this.filterItemsCollection);
            this.listenTo(this.resultsBarView, {
                'touch:filter:query': this.buildFilterQuery,
                'uncheck:all:items': this.uncheckAllItems,
                'child:uncheck:item': this.uncheckItem
            });
        },
        setSearchView: function() {
            this.searchView = this.getSearchView();
            this.listenTo(this.searchView, {
                'add:filter:item': this.addFilterItem,
                'remove:filter:items': this.removeFilterItems,
                'touch:filter:query': this.buildFilterQuery
            }, this);
        },
        setSeasonsView: function() {
            this.seasonsView = this.getSeasonsView();
            this.listenTo(this.seasonsView, {
                'add:filter:item': this.addFilterItem,
                'remove:filter:items': this.removeFilterItems
            });
        },
        setCategoriesView: function() {
            var _this = this;
            var selectedView;
            var categoriesSelectOne = this.navbarModel.get('categoriesSelectOne');
            this.categoriesFilterCollection = this.widgetOptions.categoryFilters;
            this.filterNames = [];

            _.each(this.categoriesFilterCollection, function(filter) {
                selectedView = _this.getCategoriesHolderView(filter, categoriesSelectOne);
                _this.setCategoryView(selectedView);
                _this.filterNames.push(filter.name);

                _this.listenTo(selectedView, {
                    'add:filter:item': _this.addFilterItem,
                    'remove:filter:items': _this.removeFilterItems,
                    'check:category:filter': _this.checkCategoryFilter
                });
                selectedView.listenTo(_this.filterItemsCollection, 'reset', function(collection) {
                    _this.checkCategoryFilter();
                });
            });
        },
        setPersonalizationView: function(navbarModel) {
            this.personalizationView = this.getPersonalizationView(navbarModel);
            this.listenTo(this.personalizationView, {
                'add:filter:item': this.addFilterItem,
                'remove:filter:items': this.removeFilterItems,
            });
            App.commands.setHandlers({
                'social:login': function(data) {
                    this.triggerMethod('social:login', data);
                }.bind(this.personalizationView),

                'social:login:loaded': function() {
                    this.triggerMethod('social:login:loaded');
                }.bind(this.personalizationView)
            });
        },
        setLocationView: function(navbarModel) {
            this.locationView = this.getLocationView();
            // Location Model Changes
            navbarModel.on('change:map_viewport', this.filterByLocation, this);
        },
        setMapView: function(navbarModel, photosCollection, photoLocations) {
            var _this = this;
            this.mapView = this.getMapView(navbarModel, photosCollection, photoLocations);
            this.listenTo(this.mapView, {
                'add:filter:item': this.addFilterItem,
                'remove:filter:items': this.removeFilterItems,
                'render:map:markers': this.renderMapMarkers,
                'sync:widget': this.syncWidget,
                'analytics:track': this.analyticsTrack
            });
            photosCollection.on('sync', function(collection, resp) {
                _this.mapView.triggerMethod('sync');
            });
        },
        setSortView: function(navbarModel) {
            this.sortView = this.getSortView(navbarModel);
            // Sort Model Changes
            navbarModel.on('change:sort_by', this.buildFilterQuery, this);
        },
        setViews: function(navbarModel, photosCollection, photoLocations) {
            // There will always be a layout and a results bar
            this.setLayout(navbarModel, photosCollection);
            this.setResultsBarView(navbarModel);
            // Build navbar from customization options
            if (navbarModel.get('search')) {
                this.setSearchView();
            }
            if (navbarModel.get('categories')) {
                this.setCategoriesView();
            }
            if (navbarModel.get('seasons')) {
                this.setSeasonsView();
            }
            if (navbarModel.get('personalized')) {
                this.setPersonalizationView(navbarModel);
            }
            if (navbarModel.get('location')) {
                this.setLocationView(navbarModel);
                this.setMapView(navbarModel, photosCollection, photoLocations);
            }
            if (navbarModel.get('sort')) {
                this.setSortView(navbarModel);
            }
        },
        setCategoryView: function(selectedView) {
            if (_.isFalsy(this.primaryCategoryView)) {
                this.primaryCategoryView = selectedView;
            } else if (_.isFalsy(this.secondaryCategoryView)) {
                this.secondaryCategoryView = selectedView;
            } else if (_.isFalsy(this.tertiaryCategoryView)) {
                this.tertiaryCategoryView = selectedView;
            }
        },
        getNavbarLayout: function(navbarModel, photosCollection) {
            return new Navbar.Layout({
                model: navbarModel,
                collection: photosCollection
            });
        },
        getResultsBarView: function(navbarModel, filterItemsCollection) {
            return new Navbar.resultsBar({
                model: navbarModel,
                collection: filterItemsCollection
            });
        },
        getCategoriesHolderView: function(categoriesCollection, categoriesSelectOne) {
            return new Navbar.Categories({
                name: categoriesCollection.name,
                collection: new Backbone.Collection(categoriesCollection.categories),
                categoriesSelectOne: categoriesSelectOne
            });
        },
        getLocationView: function() {
            return new Navbar.Location();
        },
        getMapView: function(navbarModel, photosCollection, photoLocations) {
            return new Navbar.Map({
                model: navbarModel,
                collection: photosCollection,
                photoLocations: photoLocations
            });
        },
        getSeasonsView: function() {
            return new Navbar.Seasons();
        },
        getSearchView: function() {
            return new Navbar.Search();
        },
        getPersonalizationView: function(navbarModel) {
            return new Navbar.Personalization({
                model: navbarModel
            });
        },
        getSortView: function(navbarModel) {
            return new Navbar.Sort({
                model: navbarModel
            });
        },
        getCategoriesRegion: function() {
            var region;
            if (_.isFalsy(this.navbarLayout.primaryCategoriesRegion.currentView)) {
                region = this.navbarLayout.primaryCategoriesRegion;
            } else if (_.isFalsy(this.navbarLayout.secondaryCategoriesRegion.currentView)) {
                region = this.navbarLayout.secondaryCategoriesRegion;
            } else if (_.isFalsy(this.navbarLayout.tertiaryCategoriesRegion.currentView)) {
                region = this.navbarLayout.tertiaryCategoriesRegion;
            }
            return region;
        },
        setCategoryTriggers: function(triggerName, argument) {
            if (!_.isFalsy(this.primaryCategoryView)) {
                this.primaryCategoryView.triggerMethod(triggerName, argument);
            }
            if (!_.isFalsy(this.secondaryCategoryView)) {
                this.secondaryCategoryView.triggerMethod(triggerName, argument);
            }
            if (!_.isFalsy(this.tertiaryCategoryView)) {
                this.tertiaryCategoryView.triggerMethod(triggerName, argument);
            }
        },
        showResultsBarView: function(view) {
            this.show(view, {
                region: this.navbarLayout.resultsBarRegion
            });
        },
        showCategoriesView: function(view) {
            var region = this.getCategoriesRegion();
            if (!_.isFalsy(view) && !_.isFalsy(region)) {
                this.show(view, {
                    region: region
                });
            }
        },
        showLocationView: function(view) {
            this.show(view, {
                region: this.navbarLayout.locationRegion
            });
        },
        showSeasonsView: function(view) {
            this.show(view, {
                region: this.navbarLayout.seasonsRegion
            });
        },
        showSearchView: function(view) {
            this.show(view, {
                region: this.navbarLayout.searchRegion
            });
        },
        showPersonalizationView: function(view) {
            this.show(view, {
                region: this.navbarLayout.personalizationRegion
            });
        },
        showSortView: function(view) {
            this.show(view, {
                region: this.navbarLayout.sortRegion
            });
        },
        showMapView: function(view) {
            this.show(view, {
                region: this.navbarLayout.mapRegion
            });
        },
        showRegions: function() {
            // Every navbar will have a resultsBar
            this.showResultsBarView(this.resultsBarView);
            if (this.navbarModel.get('search')) {
                this.showSearchView(this.searchView);
            }
            if (this.navbarModel.get('categories')) {
                this.showCategoriesView(this.primaryCategoryView);
                this.showCategoriesView(this.secondaryCategoryView);
                this.showCategoriesView(this.tertiaryCategoryView);
            }
            if (this.navbarModel.get('seasons')) {
                this.showSeasonsView(this.seasonsView);
            }
            if (this.navbarModel.get('personalized')) {
                this.showPersonalizationView(this.personalizationView);
            }
            if (this.navbarModel.get('location')) {
                this.showLocationView(this.locationView);
                this.showMapView(this.mapView);
            }
            if (this.navbarModel.get('sort')) {
                this.showSortView(this.sortView);
            }
        },
        syncWidget: function() {
            this.navbarLayout.triggerMethod('sync');
        },
        updateResultsBarCounter: function(photoCount) {
            this.resultsBarView.triggerMethod('update:results:counter', photoCount);
        },
        socialLoggedIn: function(data) {
            this.personalizationView.triggerMethod('social:login', data);
        },
        uncheckAllItems: function() {
            if (this.navbarModel.get('categories')) {
                this.setCategoryTriggers('uncheck:all:items');
            }
            if (this.navbarModel.get('seasons')) {
                this.seasonsView.triggerMethod('uncheck:all:items');
            }
            if (this.navbarModel.get('personalized')) {
                this.personalizationView.triggerMethod('uncheck:all:items');
            }
            if (this.navbarModel.get('location')) {
                this.mapView.triggerMethod('reset:map:view');
            }
        },
        uncheckItem: function(childView) {
            var targetView;
            var itemId = childView.model.get('id');
            var itemType = childView.model.get('type');

            switch (itemType) {
                case 'season':
                    targetView = this.seasonsView;
                    break;
                case 'personalization':
                    targetView = this.personalizationView;
                    break;
                case 'location':
                    targetView = this.mapView;
                    break;
                default:
                    break;
            }

            if (!_.isFalsy(targetView)) {
                if (targetView === this.mapView) {
                    targetView.triggerMethod('reset:map:view');
                } else {
                    targetView.triggerMethod('uncheck:item', itemId);
                }
            } else if (itemType === 'category') {
                this.setCategoryTriggers('uncheck:item', itemId);
            }
        },
        addFilterItem: function(itemId, itemType, itemValue, itemData, silent) {
            this.emailRedirectFilter = silent || false;
            var item = this.filterItemsCollection.findWhere({
                id: itemId,
                type: itemType
            });
            switch (itemType) {
                case 'category':
                    if (this.widgetOptions.categoriesSelectOne) {
                        // If categoriseSelectOne, then hide the dropdown every time you select one item
                        this.navbarLayout.triggerMethod('hide:drop:downs');
                        // And then reset all the counters
                        this.navbarLayout.triggerMethod('reset:categories:counter', itemId);

                        var categoryItem = this.filterItemsCollection.findWhere({
                            type: itemType
                        });
                        if (categoryItem) {
                            if (categoryItem === item) {
                                this.filterItemsCollection.remove(item);
                            } else {
                                categoryItem.set({
                                    id: itemId,
                                    type: itemType,
                                    value: itemValue,
                                    data: itemData
                                });
                            }
                            break;
                        }
                    }
                case 'season':
                case 'personalization':
                    if (item) {
                        this.filterItemsCollection.remove(item);
                        break;
                    }
                case 'location':
                case 'caption':
                    if (item) {
                        item.set({
                            value: itemValue,
                            data: itemData
                        });
                        break;
                    }
                default:
                    this.filterItemsCollection.add({
                        id: itemId,
                        type: itemType,
                        value: itemValue,
                        data: itemData
                    });
            }
            if (itemType === 'category') {
                this.checkCategoryFilter();
            }
        },
        removeFilterItems: function(itemType, categories) {
            var _this = this;
            if (_.isFalsy(itemType)) {
                this.filterItemsCollection.reset();
            } else {
                if (itemType === 'category') {
                    this.filterItemsCollection.remove(categories);
                } else {
                    var items = _.reject(this.filterItemsCollection.models, function(model) {
                        return model.get('type') === itemType;
                    }, this);
                    this.filterItemsCollection.reset(items);
                }
            }
        },
        filterByLocation: function() {
            var locationModel = this.filterItemsCollection.findWhere({
                type: 'location'
            });
            if (locationModel) {
                this.photos.resetToOriginal();
                if (this.navbarModel.get('location_active')) {
                    var viewPort = this.navbarModel.get('map_viewport');
                    var resetOriginal = false;
                    this.photos.filterPhotosWithLocation(resetOriginal, viewPort);
                }
            }
        },
        checkLocationFilter: function() {
            var locationModel = this.filterItemsCollection.findWhere({
                type: 'location'
            });
            if (locationModel) {
                var viewPort = this.navbarModel.get('map_viewport');
                var resetOriginal = true;
                this.photos.filterPhotosWithLocation(resetOriginal, viewPort);
            }
        },
        resetMapView: function() {
            this.mapView.triggerMethod('reset:map:view');
        },
        renderMapMarkers: function() {
            var locationModel = this.filterItemsCollection.findWhere({
                type: 'location'
            });
            var renderInitialMarkers = _.isFalsy(locationModel);
            this.mapView.triggerMethod('render:markers', renderInitialMarkers);
        },
        checkCategoryFilter: function() {
            var categoriesSelected = this.filterItemsCollection.findWhere({
                type: 'category'
            });
            this.setCategoryTriggers('filter:collection:change', categoriesSelected);
        },
        buildFilterQuery: function(options) {
            var _this = this;
            var query = '';
            var sortOrder = this.navbarModel.get('sort_by');
            var captionModel = this.filterItemsCollection.findWhere({
                type: 'caption'
            });
            var locationModel = this.filterItemsCollection.findWhere({
                type: 'location'
            });

            var categoriesFiltersModels = [];
            var categoriesModels;
            _.each(this.filterNames, function(filterName) {
                categoriesModels = _.invoke(_this.filterItemsCollection.filter(function(item) {
                    return item.get('data') === filterName && item.get('type') === 'category';
                }), 'get', 'id');
                if (categoriesModels.length > 0) {
                    categoriesFiltersModels.push('[' + categoriesModels.toString() + ']');
                }
            });

            var personalizationModels = _.invoke(this.filterItemsCollection.filter(function(item) {
                return item.get('type') === 'personalization';
            }), 'get', 'id');
            var seasonModels = _.invoke(this.filterItemsCollection.filter(function(item) {
                return item.get('type') === 'season';
            }), 'get', 'id');
            // Start with filters
            query += '&filters={';
            // Check if searching by caption
            if (captionModel) {
                switch (captionModel.get('data')) {
                    case 'caption':
                        query += '"filter_by_caption":{"contains":["' + captionModel.get('value') + '"],"not_contains":[]},';
                        break;
                    case 'userhandle':
                        query += '"filter_by_userhandle":{"equals":"' + captionModel.get('value') + '","not_equals":[],"contains":[],"not_contains":[]},';
                        break;
                    case 'hashtag':
                        query += '"filter_by_hashtag":{"equals":"' + captionModel.get('value') + '","not_equals":[]},';
                        break;
                    default:
                        break;
                }
            }
            // Check for category filters
            // and_categories
            // [[a,b], [c,d], [e]]
            query += !_.isFalsy(categoriesFiltersModels) ? '"and_categories":[' + categoriesFiltersModels.toString() + '],' : '';
            // Check for season filters
            query += !_.isFalsy(seasonModels) ? '"months":[' + seasonModels.toString() + '],' : '';
            // Check for personalization filters
            query += !_.isFalsy(personalizationModels) ? '"social_filters": {' : '';
            _.each(personalizationModels, function(item, i, list) {
                var platform = this.navbarModel.get('personalization_platform');
                var social_id = this.navbarModel.get('personalization_social_id');
                var access_token = this.navbarModel.get('personalization_access_token');
                var access_token_secret = this.navbarModel.get('personalization_access_token_secret');
                var longitude = this.navbarModel.get('personalization_longitude');
                var latitude = this.navbarModel.get('personalization_latitude');
                if (item === 'my_photos') {
                    query += '"my_photos":{"platform":"' + platform + '", "social_id":"' + social_id + '"}';
                } else if (item === 'near_me') {
                    query += '"near_me":{"longitude":"' + longitude + '", "latitude":"' + latitude + '"}';
                } else if (item === 'friends_photos') {
                    query += '"friends_photos":{"platform":"' + platform + '", "social_id":"' + social_id + '", "access_token":"' + access_token + '", "access_token_secret":"' + access_token_secret + '"}';
                }
                query += (i < list.length - 1) ? ', ' : '},';
            }, this);
            // Check for location filter
            query += !_.isFalsy(locationModel) ? '"view_port":[' + locationModel.get('data').toString() + '],' : '';
            // Close filters first removing trailing comma if needed
            query = query.replace(/(,$)/g, '');
            query += '}';
            // Get sort order
            switch (sortOrder) {
                case 'sort_recency':
                    query += '&sort={"recency":true,"desc":true}';
                    break;
                case 'sort_popularity':
                    query += '&sort={"popularity":true,"desc":true}';
                    break;
                case 'sort_price_high_low':
                    query += '&sort={"price":true,"desc":true}';
                    break;
                case 'sort_price_low_high':
                    query += '&sort={"price":true,"asc":true}';
                    break;
                default:
                    break;
            }

            this.navbarLayout.triggerMethod('update:filter:query', query);

            if (_.isFalsy(locationModel) && !this.emailRedirectFilter) {
                this.emailRedirectFilter = false;
                this.analyticsTrack('Apply Interactive Bar', query);
            }
        },
        analyticsTrack: function(ev, filterType, data) {
            var type;
            if (ev === 'Apply Interactive Bar') {
                var captionModel = _.invoke(this.filterItemsCollection.filter(function(item) {
                    return item.get('type') === 'caption';
                }), 'get', 'value');
                var categoriesModels = _.invoke(this.filterItemsCollection.filter(function(item) {
                    return item.get('type') === 'category';
                }), 'get', 'id');
                var seasonModels = _.invoke(this.filterItemsCollection.filter(function(item) {
                    return item.get('type') === 'season';
                }), 'get', 'value');
                type = {
                    search: captionModel || false,
                    categoryFilter: categoriesModels || false,
                    personalizationFilter: {
                        myPhotos: false,
                        myFriendPhoto: false,
                        nearMe: false
                    },
                    monthFilter: seasonModels || false,
                    locationFilter: false,
                    sort: this.navbarModel.get('sort_by')
                };
                var personalizationModels = _.invoke(this.filterItemsCollection.filter(function(item) {
                    return item.get('type') === 'personalization';
                }), 'get', 'id');
                _.each(personalizationModels, function(item, i, list) {
                    switch (item) {
                        case 'my_photos':
                            type.personalizationFilter.myPhotos = true;
                            break;
                        case 'near_me':
                            type.personalizationFilter.nearMe = true;
                            break;
                        case 'friends_photos':
                            type.personalizationFilter.myFriendsPhotos = true;
                            break;
                        default:
                            break;
                    }
                });
                if (filterType === 'location' && !_.isFalsy(data)) {
                    type.locationFilter = data;
                    data = '';
                }
            } else {
                type = filterType;
            }
            var keenData = {
                category: 'interactiveWidget',
                filterType: {
                    type: type
                },
                widgetInfo: {
                    interactiveWidgetOptions: {
                        categories: gon.display_options.interactiveWidgetOptions.categories,
                        location: gon.display_options.interactiveWidgetOptions.location,
                        personalized: gon.display_options.interactiveWidgetOptions.personalized,
                        months: gon.display_options.interactiveWidgetOptions.seasons,
                        search: gon.display_options.interactiveWidgetOptions.search,
                        sort: gon.display_options.interactiveWidgetOptions.sort,
                        sortPopular: gon.display_options.interactiveWidgetOptions.sortPopular,
                        sortPrice: gon.display_options.interactiveWidgetOptions.sortPrice,
                        sortRecent: gon.display_options.interactiveWidgetOptions.sortRecent,
                        widgetType: gon.display_options.interactiveWidgetOptions.widgetType,
                        interactiveWidgetType: gon.display_options.interactiveWidgetOptions.interactiveWidgetType,
                        numOfCategories: gon.display_options.interactiveWidgetOptions.categoryFilters.length,
                        selectedCategories: gon.display_options.interactiveWidgetOptions.selectedCategories
                    },
                    currentAlbum: {
                        id: gon.current_album.id
                    }
                },
                brandInfo: {
                    currentAccount: gon.current_account.id,
                    businessName: gon.current_account.business_name,
                    accountType: gon.current_account.account_type
                }
            };
            App.execute('interactive:widget:analytics', ev, keenData, data);
        }
    });

    App.reqres.setHandlers({
        'get:navbar:view': function(options, collection) {
            var interactiveWidgetOptions = {};
            var getCategoryAlbums = function(categories, name) {
                $.ajax({
                    url: Routes.category_list_path(accountId),
                    type: 'GET',
                    dataType: 'json',
                    data: {
                        'selected': categories
                    },
                    async: false,
                    success: function(albums) {
                        if (_.isFalsy(albums)) {
                            interactiveWidgetOptions.categories = false;
                        } else {
                            interactiveWidgetOptions.categoryFilters.push({
                                name: name,
                                categories: albums
                            });
                        }
                    }
                });
            };
            if (!_.isFalsy(options) && !_.isFalsy(options.display_options) && !_.isFalsy(options.display_options.interactiveWidgetOptions)) {
                interactiveWidgetOptions = options.display_options.interactiveWidgetOptions;
                if (interactiveWidgetOptions.categories === true) {
                    if (!_.isFalsy(options.current_account) && !_.isFalsy(options.current_account.id)) {
                        var accountId = options.current_account.id;
                        interactiveWidgetOptions.categoryFilters = [];

                        if (interactiveWidgetOptions.selectedCategories.length > 0) {
                            _.each(interactiveWidgetOptions.selectedCategories, function(filter) {
                                getCategoryAlbums(filter.categories, filter.name);
                            });
                        } else {
                            getCategoryAlbums();
                        }
                    } else {
                        interactiveWidgetOptions.categories = false;
                    }
                }
            } else {
                interactiveWidgetOptions = {
                    categories: false
                };
            }
            if (_.isFalsy(interactiveWidgetOptions.categories)) {
                interactiveWidgetOptions.categoryFilters = [];
            }
            interactiveWidgetOptions.current_album = options.current_album;
            interactiveWidgetOptions.current_account = options.current_account;
            interactiveWidgetOptions.interactiveWidgetType = interactiveWidgetOptions.widgetType;
            interactiveWidgetOptions.widgetType = options.type;
            var navbarController = new Navbar.Controller({
                photosCollection: collection,
                widgetOptions: interactiveWidgetOptions
            });
            navbarController._setMainView(navbarController.navbarLayout);
            return navbarController.navbarLayout;
        }
    });
});